import Vue from "vue";
import Vuex from "vuex";
import loader from "./loader";
import { createPersistence } from "./persistence";

Vue.use(Vuex);

const loadedStores = loader();

const reducer = (state) => {
  const persistentStore = {};
  Object.keys(loadedStores).forEach((s) => {
    const ls = loadedStores[s];
    if (!!ls.persistent) {
      ls.persistent.forEach((f) => {
        if (!persistentStore[s]) {
          persistentStore[s] = {};
        }

        persistentStore[s][f] = state[s][f];
      });
    }
  });
  return persistentStore;
};

const store = new Vuex.Store({
  modules: { ...loadedStores },
  plugins: [createPersistence(reducer)],
  strict: process.env.NODE_ENV !== "production",
});

export default store;
